var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoplLogoSmallScreenNewWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 89,
    viewBox: "0 0 218 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1979_6807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 218,
    height: 89
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.115 0H0V88.7578H217.115V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1979_6807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 88.7568V14.3573H11.5925V21.4183L12.4559 20.4973C17.1412 15.4673 23.4382 12.8105 30.6562 12.8105C46.7385 12.8105 59.2059 24.996 60.4837 41.8689L54.4285 41.7628C50.9632 41.7155 47.8434 39.5903 46.4852 36.3786C44.0791 30.7345 38.4497 24.689 29.8504 24.689C21.251 24.689 13.1466 32.4467 12.3753 42.3411C12.3292 42.8371 12.3062 43.3566 12.3062 43.9354C12.3062 44.5492 12.3292 45.1042 12.3753 45.6474C13.1351 55.7075 20.8365 63.2997 30.2648 63.2997C37.5403 63.2997 44.0216 58.7303 46.7385 51.6577C48.0163 48.3514 51.2972 46.1197 54.9004 46.1197H60.5755C59.9196 62.4616 47.1989 75.1901 31.37 75.1901C24.1059 75.1901 17.5442 72.6868 13.3653 68.3063L12.5019 67.3968V88.7686H0V88.7568Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2952 75.1783C79.5701 75.1783 65.6405 61.9184 64.6045 46.1079H70.4179C74.0096 46.1079 77.1987 48.198 78.5223 51.433C81.4463 58.5297 88.2268 63.2997 95.3988 63.2997C103.02 63.2997 109.846 58.7422 112.805 51.7046C114.232 48.3041 117.387 46.1079 120.84 46.1079H126.792C125.756 60.4897 113.806 75.1783 95.2952 75.1783ZM120.783 41.8689C117.375 41.8689 114.267 39.6963 112.863 36.3431C109.904 29.2585 103.135 24.689 95.5946 24.689C88.0543 24.689 81.5385 29.4002 78.5798 36.4022C77.1641 39.72 74.0675 41.8689 70.683 41.8689H64.6277C65.7673 24.996 78.9253 12.8105 96.1012 12.8105C104.355 12.8105 112.425 16.2702 118.238 22.292C123.258 27.4992 126.274 34.4422 126.769 41.8807H120.771L120.783 41.8689Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.191 88.7568V46.1079H137.752C141.344 46.1079 144.613 48.3159 145.891 51.5986C148.654 58.7067 155.146 63.2997 162.445 63.2997C171.908 63.2997 179.563 55.7075 180.254 45.6356C180.288 45.1515 180.3 44.6556 180.3 44.1478C180.3 43.581 180.265 42.9908 180.219 42.353C179.356 33.6746 172.322 24.7008 162.042 24.7008C155.215 24.7008 148.746 29.412 145.937 36.4259C144.613 39.7436 141.413 41.8807 137.809 41.8807H132.191V14.3573H143.784V21.4183L144.647 20.4973C149.333 15.4673 155.63 12.8105 162.848 12.8105C179.103 12.8105 191.662 25.2557 192.721 42.4239C192.767 43.1205 192.802 43.8881 192.802 44.7739C192.802 45.0451 192.802 45.2931 192.779 45.5528C192.387 62.1782 179.551 75.1783 163.562 75.1783C156.194 75.1783 149.805 72.7342 145.546 68.2945L144.682 67.3969V88.7568H132.191Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.668 0H198.178V61.6947C198.178 68.7674 203.773 74.506 210.668 74.506V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.178 61.6953C198.178 68.768 203.773 74.5066 210.668 74.5066H217.115V61.6953H198.178Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoplLogoSmallScreenNewWhite);
export default __webpack_public_path__ + "static/media/popl_logo_small_screen_new_white.b290ba50c1cf86c855fe22e9090d3f27.svg";
export { ForwardRef as ReactComponent };